<div
    class="invintory-modal"
    [ngClass]="{
        'w-100': addressForm,
        'invintory-map': environmentVariables?.ENABLE_PROFILE_SET_AREA_FROM_MAP,
        'invintory-drop-dwon':
            !environmentVariables?.ENABLE_PROFILE_SET_AREA_FROM_MAP,
            'max-w-1000': !addressForm
    }"
>
    <div *ngIf="!environmentVariables?.ENABLE_PROFILE_SET_AREA_FROM_MAP">
        <div class="area-title-inv">
            <h5 class="main-font">
                <span
                    *ngIf="
                        environmentVariables?.PICKUP_DELIVERY_SOURCE_Backup ==
                        'both'
                    "
                    (click)="backToBoth()"
                    class="material-icons back-btn"
                    >{{ lang == "en" ? "chevron_left" : "chevron_right" }}</span
                >
                {{ "input_text.selectArea" | translate }}
            </h5>
            <mat-icon
                (click)="hideMultiInv()"
                *ngIf="user?.area?.id || user?.branch"
                >close</mat-icon
            >
        </div>
        <div *ngIf="productList?.length > 0" class="alert-inventory">
            {{ "removeItems" | translate }}
        </div>
        <div
            *ngIf="cities?.length == 0 && !loadingCities"
            class="alert-inventory"
        >
            {{ "noAreas" | translate }}
        </div>
        <form
            *ngIf="cities && cities.length > 0"
            [formGroup]="areaForm"
            [ngClass]="{ 'text-right': lang == 'ar' }"
        >
            <div class="row">
                <div class="col-md-12">
                    <mat-form-field
                        [ngClass]="{ 'text-right': lang == 'ar' }"
                        class="w-100"
                    >
                        <app-loading *ngIf="loading"></app-loading>
                        <mat-select
                            (selectionChange)="
                                resetArea(); getArea($event.value)
                            "
                            formControlName="city_id"
                            placeholder="{{ 'prescription.city' | translate }}"
                        >
                            <ng-container *ngFor="let city of cities">
                                <mat-option [value]="city.id">
                                    {{ city.name }}
                                </mat-option>
                            </ng-container>
                        </mat-select>
                        <mat-error
                            *ngIf="areaForm.controls.city_id.errors?.required"
                            translate
                        >
                            {{
                                "prescription.cityRequired" | translate
                            }}</mat-error
                        >
                    </mat-form-field>
                </div>
                <div *ngIf="areaList?.length > 0" class="col-md-12">
                    <mat-form-field
                        [ngClass]="{ 'text-right': lang == 'ar' }"
                        class="w-100"
                    >
                        <app-loading *ngIf="loading"></app-loading>
                        <mat-select
                            formControlName="area_id"
                            placeholder="{{ 'prescription.area' | translate }}"
                        >
                            <ng-container *ngFor="let city of areaList">
                                <mat-option [value]="city.id">
                                    {{ city.name }}
                                </mat-option>
                            </ng-container>
                        </mat-select>
                        <mat-error
                            *ngIf="areaForm.controls.area_id.errors?.required"
                            translate
                        >
                            {{
                                "prescription.areaRequired" | translate
                            }}</mat-error
                        >
                    </mat-form-field>
                </div>
                <div
                    *ngIf="
                        areaList?.length == 0 &&
                        cities?.length > 0 &&
                        areaForm.value.city_id
                    "
                    class="col-md-12"
                >
                    <div class="alert-inventory">
                        {{ "noAreas" | translate }}
                    </div>
                </div>

                <div *ngIf="areaList?.length > 0" class="col-md-12">
                    <button
                        (click)="onAreaFormSubmit('drpodown')"
                        [disabled]="loadingSpinner"
                        class="primary-button"
                        mat-raised-button
                    >
                        {{ "prescription.save" | translate }}
                        <app-loading *ngIf="loadingSpinner"></app-loading>
                    </button>
                </div>
            </div>
        </form>
        <div
            *ngIf="cities?.length == 0 && loading"
            class="position-absolute loading"
        >
            <img  loading="lazy"  src="./../../../assets/images/Spinner-loading.svg"    alt="loading image" />
        </div>
    </div>

    <div
        class="map-inventory"
        *ngIf="environmentVariables?.ENABLE_PROFILE_SET_AREA_FROM_MAP"
    >
        <div *ngIf="addressForm" class="area-title-inv mx-1">
            <div></div>
            <div class="location-icon-container">
                <mat-icon
                    *ngIf="!mapLoading"
                    class="location-icon"
                    (click)="showPosition('location')"
                    >my_location</mat-icon
                >
            </div>
        </div>
        <div *ngIf="!addressForm" class="area-title-inv mx-1">
            <h5 class="main-font">
                <span
                    *ngIf="
                        environmentVariables?.PICKUP_DELIVERY_SOURCE_Backup ==
                        'both'
                    "
                    (click)="backToBoth()"
                    class="material-icons back-btn"
                    >{{ lang == "en" ? "chevron_left" : "chevron_right" }}</span
                >
                {{ "input_text.selectArea" | translate }}
            </h5>
            <!-- <p>  {{cordnates?.lat_marker}} {{cordnates?.lng_marker}}</p><hr>
      <p>  {{cordnates?.lat}} {{cordnates?.lng}}</p> -->
            <mat-icon
                class="close-icon mx-2"
                (click)="hideMultiInv()"
                *ngIf="user?.area?.id || user?.branch"
                >close</mat-icon
            >

            <!-- <mat-icon class="location-icon" (click)="setCurrentPosition('current-location')"
          >my_location</mat-icon
      > -->
            <div class="location-icon-container">
                <mat-icon
                    *ngIf="!mapLoading"
                    class="location-icon"
                    (click)="showPosition('location')"
                    >my_location</mat-icon
                >
            </div>

            <!-- <span class="material-symbols-outlined">
        my_location
        </span> -->
        </div>
        <div class="mluti-inv-gm-svpc map">
            <app-loading *ngIf="mapLoading"></app-loading>
            <agm-map
                #agmMap
                [latitude]="cordnates.lat"
                [longitude]="cordnates.lng"
                [zoom]="zoom"
                [zoomControl]="true"
                (centerChange)="centerChanged($event)"
                (mapReady)="mapReady($event)"
                (zoomChange)="zoomMp($event)"
                [keyboardShortcuts]="false"
            >
                <agm-info-window #infowindow>
                    <div
                        class="agm-info-window-content px-3 py-2"
                        id="info-window"
                    >
                        <span>
                            {{
                                "prescription.locationServiceDisabled"
                                    | translate
                            }}
                        </span>

                        <mat-icon
                            class="info-window-close-icon"
                            (click)="clickedMarker()"
                            >close</mat-icon
                        >
                    </div>
                </agm-info-window>
                <agm-polygon
                    *ngFor="let polygon of coordnatesPaths"
                    [strokeColor]="'green'"
                    [fillColor]="'#188038c9'"
                    [fillOpacity]="
                        environmentVariables?.HIDE_POLYGON_ON_MAP ? 0 : 0.3
                    "
                    [strokeOpacity]="
                        environmentVariables?.HIDE_POLYGON_ON_MAP ? 0 : 1
                    "
                    [strokeWeight]="
                        environmentVariables?.HIDE_POLYGON_ON_MAP ? 0 : 2
                    "
                    [paths]="polygon"
                >
                </agm-polygon>

                <div
                    class="map-center-overlay"
                    *ngIf="
                        cordnates?.lat_marker !== 0 &&
                        cordnates.lng_marker !== 0
                    "
                    [attr.latitude]="cordnates.lat_marker"
                    [attr.longitude]="cordnates.lng_marker"
                >
                    <img  loading="lazy" 
                        src="../../../assets/images/marker.svg"
                           alt="marker image"
                        width="30"
                        height="30"
                    />
                </div>
            </agm-map>
        </div>

        <!-- [ngClass]="{'d-none' : isPleaseZoom}" -->
        <!-- areaDataMessage?.length == 0 ||  -->
        <div class="col-md-12 mt-2 mx-3">
            <div *ngIf="!isPleaseZoom">
                <mat-icon *ngIf="areaData?.data?.active"> pin_drop </mat-icon>
                <!-- <span class="pin-details mx-2" *ngIf="!areaData?.data?.active">
        {{areaData?.data}}
   </span> -->
                <span class="pin-details mx-2" *ngIf="areaData?.data?.active">
                    <ng-container *ngIf="!addressForm">{{
                        "prescription.deliveryTo" | translate
                    }}</ng-container>

                    {{ "prescription.city" | translate }} :
                    <span *ngIf="lang == 'en'">
                        {{ areaData?.data?.city?.name }}
                    </span>
                    <span *ngIf="lang == 'ar'">
                        {{ areaData?.data?.city?.name_ar }}
                    </span>
                    -
                    {{ "prescription.area" | translate }} :
                    <span *ngIf="lang == 'ar'"
                        >{{ areaData?.data?.name_ar }}
                    </span>
                    <span *ngIf="lang == 'en'">{{ areaData?.data?.name }}</span>
                    <span *ngIf="areaData?.data?.address">
                        -
                        {{ "prescription.address" | translate }} :
                        <span
                            >
                            {{areaData?.data?.address }}
                        </span>
                    </span>
               


                </span>
            </div>
            <div
                *ngIf="
                    addressForm &&
                    (areaData?.errors || loadingSpinnerDrag || isPleaseZoom)
                "
                class="area-errors"
            >
                <p *ngIf="areaData?.errors && !isPleaseZoom">
                    {{ areaDataMessage }}
                </p>
                <p *ngIf="isPleaseZoom" class="please-zoom-map">
                    {{ "prescription.zoomInTheMap" | translate }}
                </p>
                <app-loading *ngIf="loadingSpinnerDrag"></app-loading>
            </div>
            <button
                *ngIf="!addressForm"
                (click)="onAreaFormSubmit('map')"
                [disabled]="loadingSpinnerDrag"
                class="primary-button"
                [ngClass]="{
                    'disable-Save-button': areaDataMessage?.length !== 0,
                    'disable-Save-button-zoom': isPleaseZoom
                }"
                mat-raised-button
            >
                <span>
                    <!-- <span *ngIf="areaDataMessage?.length == 0 || areaData?.data?.active">
    {{ "prescription.save" | translate }}
  </span> -->
                    <!-- areaData?.data &&  -->
                    <span *ngIf="areaData?.data && !isPleaseZoom">
                        {{ "prescription.save" | translate }}
                    </span>
                    <span *ngIf="areaData?.errors && !isPleaseZoom">
                        {{ areaDataMessage }}
                    </span>
                    <span *ngIf="isPleaseZoom" class="please-zoom-map">
                        {{ "prescription.zoomInTheMap" | translate }}
                    </span>
                </span>

                <app-loading *ngIf="loadingSpinnerDrag"></app-loading>
            </button>
        </div>
    </div>
</div>
